import React from 'react';
import { Form } from 'react-bootstrap';

import FormRow from '../../../app/components/FormRow';
import { CreateUpdateCompanyDto } from '../../../common/spdCore/autogenerated/spdApiClient/models/CreateUpdateCompanyDto';
import BatteryMultiSelector from '../Battery/BatteryMultiSelector';
import { ReactSelectOption } from '../Selects/SortableSelect';
import HealthcareFacilitySelector from '../Selects/HealthcareFacilitySelector';

interface CompanyEditorTabExternalReferralProps {
  company: CreateUpdateCompanyDto;
  propertyChange: (obj: Partial<CreateUpdateCompanyDto>) => void;
  batteries: ReactSelectOption[];
  handleClick: (tempBatteries: ReactSelectOption[]) => void;
  readOnly: boolean;
}

export const CompanyEditorTabExternalReferral: React.FC<
  CompanyEditorTabExternalReferralProps
> = ({ company, propertyChange, batteries, handleClick, readOnly }) => {
  return (
    <Form className="d-grid gap-3">
      <FormRow
        controlId="externalReferral"
        label="Wystawiają skierowania w systemie"
      >
        <Form.Check
          type="checkbox"
          checked={company?.externalReferral ? true : false}
          onChange={e => propertyChange({ externalReferral: e.target.checked })}
          disabled={readOnly}
        />
      </FormRow>
      <FormRow controlId="healthcareFacility" label="Placówka">
        <HealthcareFacilitySelector
          value={company?.healthcareFacilityId || ''}
          onChange={e => propertyChange({ healthcareFacilityId: e.value })}
          clearable={true}
        />
      </FormRow>
      <FormRow controlId="battery" label="Bateria testów">
        <BatteryMultiSelector
          selectedBattery={batteries}
          onChange={options => handleClick((options || []).map(o => o))}
        />
      </FormRow>
    </Form>
  );
};
